module.exports = __webpack_public_path__ + "static/img/11youxiu.02df7df5.gif";